let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lak6L")).then(() => parcelRequire('b3xxh'));